import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { FacebookConfig } from '../config/facebook.config';
import { AuthEventsEmitter } from '../events/auth.events';
import { StorageService } from './storage.service';
var SocialService = /** @class */ (function () {
    function SocialService(httpClient, facebookConfig, storageService, authEventsEmitter) {
        var _this = this;
        this.httpClient = httpClient;
        this.facebookConfig = facebookConfig;
        this.storageService = storageService;
        this.authEventsEmitter = authEventsEmitter;
        this.FACEBOOK_ID = 'FACEBOOK_ID';
        this.initFacebook();
        this.initFacebookSDK();
        this.facebookId = this.getFacebookId();
        this.authEventsEmitter.facebookIdChanged$
            .subscribe(function (facebookId) {
            _this.facebookId = facebookId;
            _this.setFacebookId(facebookId);
        });
        this.authEventsEmitter.tokenChanged$
            .subscribe(function (token) {
            if (!token) {
                delete _this.facebookId;
                _this.deleteFacebookId();
            }
        });
    }
    SocialService.prototype.initFacebook = function () {
        var _this = this;
        window.fbAsyncInit = function () {
            _this.initFacebookSDK();
        };
    };
    SocialService.prototype.initFacebookSDK = function () {
        try {
            FB.init(this.facebookConfig);
        }
        catch (e) {
            // we do not really need to handle this error
        }
    };
    SocialService.prototype.openFacebookLoginDialog = function () {
        var _this = this;
        return new Observable(function (observer) {
            FB.login(function (response) {
                if (response.authResponse) {
                    _this.authEventsEmitter.broadcastFacebookIdChanged(response.authResponse.userID);
                    observer.next(response);
                }
                else {
                    observer.error(response);
                }
                observer.complete();
            }, {
                scope: 'email'
            });
        });
    };
    SocialService.prototype.getFacebookProfilePictureUrl = function (userID) {
        var _this = this;
        return new Observable(function (observer) {
            _this.httpClient.get("https://graph.facebook.com/" + userID + "/picture?type=square&redirect=0")
                .subscribe(function (_a) {
                var url = _a.data.url;
                observer.next(url);
                observer.complete();
            }, function (err) {
                observer.error(err);
            });
        });
    };
    SocialService.prototype.getFacebookInfo = function (userID) {
        return new Observable(function (observer) {
            FB.api("/" + userID + "/?fields=email", 'get', {}, (function (_a) {
                var email = _a.email, first_name = _a.first_name, last_name = _a.last_name;
                observer.next({
                    email: email,
                    first_name: first_name,
                    last_name: last_name
                });
                observer.complete();
            }));
        });
    };
    SocialService.prototype.getFacebookFriends = function (userID, accessToken) {
        return new Observable(function (observer) {
            FB.api("/" + userID + "/friends?access_token=" + accessToken, 'get', {}, function (_a) {
                var data = _a.data;
                observer.next(null);
                observer.complete();
            });
        });
    };
    SocialService.prototype.getFacebookId = function () {
        return this.storageService.getItem(this.FACEBOOK_ID);
    };
    SocialService.prototype.setFacebookId = function (facebookId) {
        this.storageService.setItem(this.FACEBOOK_ID, facebookId);
    };
    SocialService.prototype.deleteFacebookId = function () {
        this.storageService.removeItem(this.FACEBOOK_ID);
    };
    Object.defineProperty(SocialService.prototype, "userIsLoggedInFacebook", {
        get: function () {
            return !!this.facebookId;
        },
        enumerable: true,
        configurable: true
    });
    return SocialService;
}());
export { SocialService };
